import React from 'react';
import { SearchInput, SearchInputProps } from 'evergreen-ui';
import { useDebounce } from 'helper/useDebounce';

export type SearchInputByNameProps = SearchInputProps & {
  value: string,
  updateValue: (text: string) => void,
  /**
   * задержка при `updateValue` в мс
   * @default 500
   */
  debounceDelay?: number,
  placeholder?: string,
}

/** Строка ввода, где при updateValue происходит задержка (debounce) */
export function SearchInputByName({
  value = '',
  updateValue,
  debounceDelay = 500,
  placeholder = 'Название',
  ...props
}: SearchInputByNameProps) {
  const [searchText, setSearchText] = React.useState(value);
  React.useEffect(() => {
    // костыль на случай сброса фильтра, с другими значениями работать не будет
    if (value === '') {
      setSearchText('');
    }
  }, [value]);

  // TODO: проверить работоспособность
  const delayedUpdateValue = useDebounce(updateValue, debounceDelay);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const { target: { value: inputValue } } = event;
    setSearchText(inputValue);
    delayedUpdateValue(inputValue);
    props.onChange && props.onChange(event);
  };

  return (
    <SearchInput
      placeholder={placeholder}
      width="100%"
      value={searchText}
      {...props}
      onChange={onChange}
    />
  );
}
export const MemoSearchInputByName = React.memo(SearchInputByName);
MemoSearchInputByName.displayName = 'MemoSearchInputByName';
export default SearchInputByName;
